// @flow
import React from 'react';
import ContextMenuItem from '../util/ContextMenuItem';
import IconLabel from '../util/IconLabel';
import type { IntlShape } from 'react-intl';
import { injectIntl } from 'react-intl';
import { commonMessages } from '../messages/Common';

declare var __CAPACITOR__: boolean;

type OwnProps = {
  onClick: Function,
  active: boolean,
  intl: IntlShape,
  disabled?: boolean,
};

const CollectionContextMenuItem = ({ onClick, active, intl, disabled }: OwnProps) => (
  <ContextMenuItem
    onClick={onClick}
    keepOpenAfterClick={!__CAPACITOR__}
    data-test="context-menu.toggle-collection"
    disabled={disabled}
  >
    {active ? (
      <React.Fragment>
        <IconLabel
          name="heart-block"
          size="default"
          labelVisible
          label={intl.formatMessage(commonMessages.removeFromCollection)}
        />
      </React.Fragment>
    ) : (
      <React.Fragment>
        <IconLabel
          name="heart"
          size="default"
          labelVisible
          label={intl.formatMessage(commonMessages.saveToCollection)}
        />
      </React.Fragment>
    )}
  </ContextMenuItem>
);

export default injectIntl(CollectionContextMenuItem);
